export default "__VITE_ASSET__df01150d__"